/* SEP-POPUP-START v1.0 (24-10-2026) | SEROA signup popup | SERO7KX | Klaviyo list WdXdR5 (Welcome) | kopie ML-popup v2 (live) */
(function () {
  'use strict';
  var KEY = 'se_popup_v1';
  var DAY = 86400000;
  var qs = location.search;
  var FORCE = /[?&](?:sepopup=(?:force|ebf)|ebf=1)/.test(qs);   /* 24-10: ?sepopup=ebf of ?ebf=1 = test, altijd tonen */
  var path = location.pathname.toLowerCase();
  /* 25-10 Lenn: 35 s na BINNENKOMST op de site (sessie), niet per pagina. Start telt ook op pagina's waar de pop-up niet mag */
  var SES_START = Date.now();
  try { var ss0 = parseInt(sessionStorage.getItem('popup_sessie_start'), 10);
    if (ss0 > 0 && ss0 <= SES_START) SES_START = ss0; else sessionStorage.setItem('popup_sessie_start', String(SES_START)); } catch (eSS) {}

  /* never on these paths (with or without locale prefix) */
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|account|pages|policies)(?:\/|$)/.test(path)) return;
  if (path.indexOf('/checkouts') !== -1 || path.indexOf('/apps/') !== -1) return;
  /* not for visitors arriving from our own mails */
  if (!FORCE && /utm_source=klaviyo/i.test(qs)) return;

  function st() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  /* 24-10: aanmelding via de footer (Shopify-nieuwsbrief) telt als aangemeld: pop-up komt dan niet meer */
  if (/customer_posted=true/.test(qs + location.hash)) { var S0 = st(); S0.done = Date.now(); save(S0); }
  document.addEventListener('submit', function (ev) { try { var f = ev.target; if (!f || f.id === 'SEP-form') return;
    var ft = f.querySelector('input[name="form_type"]'); var ce = f.querySelector('input[name="contact[email]"],input[type="email"]');
    if (ft && ft.value === 'customer' && ce && ce.value) { var s9 = st(); s9.done = Date.now(); save(s9); } } catch (e9) {} }, true);
  var S = st(), now = Date.now();
  if (!FORCE) {
    if (S.done && now - S.done < 365 * DAY) return;
    if (S.until && now < S.until) return;
  }

  /* taal = Shopify.locale (markt-URL); zonder prefix = wortelmarkt 'fr'. lb (Luxemburg) = de */
  var seg = (path.split('/')[1] || '');
  var segMap = {};
  var lang = null;
  var srcLoc = /^[a-z]{2}-[a-z]{2}$/.test(seg) ? seg : 'fr';

  function init() {
    var dictEl = document.getElementById('SEP-i18n');
    var card = document.getElementById('SEP-card');
    var back = document.getElementById('SEP-backdrop');
    if (!dictEl || !card || !back) return;
    var I18N; try { I18N = JSON.parse(dictEl.textContent); } catch (e) { return; }
    if (!lang) {
      var sl = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').split('-')[0].toLowerCase();
      if (sl === 'lb') sl = 'de';
      lang = I18N[sl] ? sl : (I18N['fr'] ? 'fr' : 'en');
    }
    var T = I18N[lang] || I18N.en;
    function put(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    put('SEP-title', T.title); put('SEP-sub', T.sub);
    put('SEP-fn-l', T.fn); put('SEP-em-l', T.em);
    put('SEP-t-ml', T.min); put('SEP-t-sl', T.sec);
    put('SEP-go', T.cta); put('SEP-no', T.no);
    put('SEP-s-title', T.stitle); put('SEP-s-note', T.snote); put('SEP-s-btn', T.sbtn);
    put('SEP-copy-t', T.copy);
    put('SEP-l1', T.lpre); put('SEP-llink', T.llink); put('SEP-l2', T.lpost);
    var ppHref = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'policies/privacy-policy';
    document.getElementById('SEP-llink').setAttribute('href', ppHref);
    document.getElementById('SEP-x').setAttribute('aria-label', T.close);

    if (window.SEP_EBF) { try { window.SEP_EBF(T, lang, card); } catch (eE) {} }   /* 24-10: Early Black Friday-laag (snippet se-popup-ebf) */
    /* countdown 03:00, stops at 0:00, form stays usable */
    var left = 180, tick = null;
    function renderT() {
      var m = Math.floor(left / 60), s = left % 60;
      put('SEP-t-m', (m < 10 ? '0' : '') + m);
      put('SEP-t-s', (s < 10 ? '0' : '') + s);
    }
    function startTimer() {
      renderT();
      tick = setInterval(function () {
        left -= 1;
        if (left <= 0) { left = 0; clearInterval(tick); }
        renderT();
      }, 1000);
    }

    var shown = false, prevFocus = null, prevOverflow = '';
    function open() {
      if (shown) return; shown = true;
      prevFocus = document.activeElement;
      back.hidden = false; card.hidden = false;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        back.className = 'sep-on'; card.classList.add('sep-on');
      }); });
      startTimer();
      /* lightweight shown counter (local only; Klaviyo client/events is CORS-blocked, see report) */
      var s = st(); s.shown = (s.shown || 0) + 1; s.lastShown = Date.now(); save(s);
      document.addEventListener('keydown', onKey, true);
    }
    function close(dismiss) {
      back.className = ''; card.classList.remove('sep-on');
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey, true);
      if (tick) clearInterval(tick);
      setTimeout(function () { back.hidden = true; card.hidden = true; }, 330);
      if (prevFocus && prevFocus.focus) { try { prevFocus.focus(); } catch (e) {} }
      if (dismiss) {
        var s = st(); s.n = (s.n || 0) + 1;
        s.until = Date.now() + (s.n >= 2 ? 30 : 7) * DAY;
        save(s);
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var f = card.querySelectorAll('button,input,[href]');
      var v = []; for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) v.push(f[i]); }
      if (!v.length) return;
      var first = v[0], last = v[v.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    back.addEventListener('click', function () { close(true); });
    document.getElementById('SEP-x').addEventListener('click', function () { close(true); });
    document.getElementById('SEP-no').addEventListener('click', function () { close(true); });
    document.getElementById('SEP-s-btn').addEventListener('click', function () { close(false); });

    /* copy code: clipboard API + select-on-tap fallback */
    var copyBtn = document.getElementById('SEP-copy');
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('SEP-code').textContent.trim();
      function ok() {
        var t = document.getElementById('SEP-copy-t');
        t.textContent = T.copied;
        setTimeout(function () { t.textContent = T.copy; }, 2000);
      }
      function fallback() {
        var el = document.getElementById('SEP-code');
        try {
          var rng = document.createRange(); rng.selectNodeContents(el);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(rng);
          if (document.execCommand && document.execCommand('copy')) ok();
        } catch (e) {}
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok, fallback);
      } else { fallback(); }
    });

    /* submit via legacy kmail endpoint (form-encoded = simple request, no CORS preflight; proven in POPUP_REPORT.md) */
    var form = document.getElementById('SEP-form');
    var err = document.getElementById('SEP-err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = document.getElementById('SEP-em').value.trim();
      var fn = document.getElementById('SEP-fn').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
        err.textContent = T.err; err.classList.add('sep-show'); return;
      }
      err.classList.remove('sep-show');
      var btn = document.getElementById('SEP-go');
      btn.disabled = true;
      var body = 'g=WdXdR5&company_id=RAkSsa' +
        '&email=' + encodeURIComponent(em) +
        '&first_name=' + encodeURIComponent(fn) +
        '&%24source=' + encodeURIComponent('SEROA Popup ' + srcLoc) +
        '&ml_taal=' + encodeURIComponent(lang || '') + '&%24fields=%24source%2Cfirst_name%2Cml_taal';
      function succeed() {
        form.classList.add('sep-hide');
        document.getElementById('SEP-success').classList.add('sep-show');
        if (tick) clearInterval(tick);
        var s = st(); s.done = Date.now(); save(s);
        try { document.getElementById('SEP-s-btn').focus({ preventScroll: true }); } catch (e2) {}
      }
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: body
      }).then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (j) {
          btn.disabled = false;
          if (j && j.success !== false) { succeed(); }
          else { err.textContent = T.err; err.classList.add('sep-show'); }
        })
        .catch(function () { btn.disabled = false; err.textContent = T.err; err.classList.add('sep-show'); });
    });

    function maybeOpen() {
      try {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          /* popup_protectie_2710 Lenn: shipping protection telt niet als product in de cart (app zet die er soms zelf in) */
          var PR = new RegExp("shipping protection|package protection|order protection|parcel protection|insured shipping|envoi assur\u00e9|envoi assure|livraison assur\u00e9e|verzekerde verzending|verzekerd verzenden|versicherter versand|versandschutz|paketschutz|env\u00edo asegurado|envio asegurado|spedizione assicurata|forsikret forsendelse|f\u00f6rs\u00e4krad frakt|ubezpieczona wysy\u0142ka|ubezpieczona przesy\u0142ka|poji\u0161t\u011bn\u00e1 doprava|poji\u0161t\u011bn\u00e1 z\u00e1silka|livrare asigurat\u0103|vakuutettu toimitus|apdraustas siuntimas|protezione spedizione|forsendelsesbeskyttelse|versandversicherung|verzendbescherming|protection d.exp[\u00e9e]dition|protecci[\u00f3o]n de env[\u00edi]o|ochrona przesy[\u0142l]ki|fraktskydd|ochrana z[\u00e1a]silky|toimitussuoja|protec[\u021bt]ia livr[\u0103a]rii", 'i'), PT = ["shipping protection", "slidecart - shipping protection", "snap cart drawer - shipping protection"], PI = ["7612524593286"];
          var echt = 0; ((c && c.items) || []).forEach(function (it) { var t = [it.title, it.product_title, String(it.handle || '').replace(/[-_]+/g, ' ')].join(' ');
            if (PR.test(t) || PT.indexOf(String(it.product_type || '').trim().toLowerCase()) > -1 || PI.indexOf(String(it.product_id)) > -1) return; echt += (it.quantity || 1); });
          if (c && !c.items && c.item_count > 0) return;
          if (echt > 0) return;
          open();
        }).catch(function () { open(); });
      } catch (e) { open(); }
    }
    /* trigger: 25s met cart-check; desktop exit intent */
    if (FORCE) { open(); return; }
    var rest = 35000 - (Date.now() - SES_START);   /* 25-10: resterende sessietijd; al voorbij = na 1,5 s, nooit direct bij laden */
    setTimeout(maybeOpen, rest > 1500 ? rest : 1500);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(min-width:768px)').matches) maybeOpen();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* SEP-POPUP-END */
